import { Link } from 'react-router-dom';
import type { DefaultTheme } from 'styled-components/macro';
import styled, { css } from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';

type UserInfoPropsT = {
  iconOnly?: boolean;
};

const baseNavControl = css`
  justify-content: center;
  width: 100%;
  height: auto;
  padding: 1rem 0.875rem;
  font-size: ${({ theme }): string => theme.fontSize['2xl']};
  font-weight: ${({ theme }): string => theme.fontWeight.medium.toString()};
`;

export const FlexContainerStyled = styled(FlexContainer)<UserInfoPropsT>`
  padding: ${({ iconOnly }): string => (!iconOnly ? '0 1.5rem' : '')};
`;

export const ButtonIconStyled = styled(ButtonIcon)`
  background: ${({ theme }): string => theme.colors.transparent};
  @media (hover: hover) {
    &:hover {
      svg path {
        fill: ${({ theme }): string => theme.colors.highlight.variant1};
      }
    }
  }
`;

export const getPopupContentStyle = (
  theme: DefaultTheme,
  isMobile: boolean
): Record<string, string> => ({
  minWidth: isMobile ? '180px' : '120px',
  borderRadius: theme.radius.sm,
});

export const ButtonStyled = styled(Button)`
  ${baseNavControl}

  ${({ theme }): string => `
  ${theme.devices.tablet} {
    padding: 0.875rem;
    font-size: ${theme.fontSize.md};
  }
`}
`;

export const LinkStyled = styled(Link)`
  ${baseNavControl}

  display: inline-flex;
  color: ${({ theme }): string => theme.colors.primary.variant1};

  ${({ theme }): string => `
  ${theme.devices.tablet} {
    padding: 0.875rem;
    font-size: ${theme.fontSize.md};
  }
`}
`;

export const DropdownItemStyled = styled.li`
  &:hover {
    background-color: ${({ theme }): string => theme.colors.surface};
  }

  &:first-child {
    border-radius: ${({ theme }): string => `${theme.radius.sm} ${theme.radius.sm} 0 0`};
  }

  &:last-child {
    border-radius: 0 0 ${({ theme }): string => `${theme.radius.sm} ${theme.radius.sm}`};
  }
`;
